import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFilterTextFieldValue } from '@features/filter/static/filterUtil';

import { updateTextItemInGlobalFilter } from '@store/actions/FilterAction';

const OrderPageSort = () => {
	const filterData = useSelector((store) => store.filterFieldStore);
	const inputValue = getFilterTextFieldValue(filterData, 'sort', 'sort-order');
	const dispatch = useDispatch();

	const handleChange = (e) => {
		let { value } = e.target;
		let data = {
			name: 'sort',
			type: 'text',
			key: value === 'Newest first' ? 'id,desc' : 'id,asc',
			value: value,
			identifier: 'sort-order'
		};
		dispatch(updateTextItemInGlobalFilter(data));
	};

	return (
		<div className="sort-button mr-2 pr-1">
			<select
				name="sort"
				id
				onChange={handleChange}
				className={
					inputValue?.value === 'Newest first'
						? 'by-order border-0 bg-transparent'
						: 'by-tna-status border-0 bg-transparent'
				}
			>
				<option value={'Newest first'} selected={inputValue?.value === 'Newest first'}>
					Newest first
				</option>
				<option value={'Oldest first'} selected={inputValue?.value === 'Oldest first'}>
					Oldest first
				</option>
			</select>
		</div>
	);
};

export default OrderPageSort;
